import { useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import {paymentJsLoadedState} from "../../state/atoms";
import DashboardApi from "../../api/DashboardApi";
import {Spinner} from "../account/misc/Spinner";
import './RegStepTrial.scss';

interface RegStepTrialProps {
  onNext: () => void;
}

export default function RegStepTrial({onNext}: RegStepTrialProps) {
  const divRef = useRef<HTMLDivElement>(null);
  const paymentJsLoaded = useRecoilValue(paymentJsLoadedState);
  const [memberId, setMemberId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    DashboardApi.status().then((resp) => {
      const {member} = resp.data;
      setMemberId(member?.id ?? '');
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!divRef.current || !paymentJsLoaded || !memberId) return;

    window.MHM.Components.trialForm({
      memberId,
      container: divRef.current,
      onSuccess: onNext
    });
  }, [divRef, paymentJsLoaded, onNext, memberId]);
  return loading ? <div className={'spinner'}><Spinner/></div> : <div ref={divRef} style={{height: '100%'}}></div>;
}
